<script setup lang="ts">
  import { computed } from 'vue'

  import { useI18n } from 'vue-i18n'

  import { MessageCircle02Icon } from '@gohighlevel/ghl-icons/24/outline'

  import CPBadge from '@ui/components/CPBadge.vue'
  import CPButton from '@ui/components/CPButton.vue'

  const props = defineProps({
    buttonId: {
      type: String,
      required: true,
    },
    badgeId: {
      type: String,
      required: true,
    },
    unreadCount: {
      type: Number,
      default: 0,
    },

    buttonClass: {
      type: String,
      default: '',
    },
  })

  const emit = defineEmits<{
    (e: 'click'): void
  }>()

  const { t } = useI18n()

  const badgeValue = computed(() => {
    return props.unreadCount > 9 ? '9+' : props.unreadCount
  })

  const badgeOffset = computed(() => {
    return props.unreadCount < 10 ? ([0, 0] as [number, number]) : ([2, -2] as [number, number])
  })
</script>

<template>
  <CPButton
    :id="props.buttonId"
    type="ghost"
    size="sm"
    color="transparent"
    :class="props.buttonClass"
    :aria-label="t('common.chat.openChat')"
    @click="emit('click')"
  >
    <CPBadge :id="props.badgeId" class="topbar-chat-badge" :show="props.unreadCount > 0" :value="badgeValue" :offset="badgeOffset">
      <MessageCircle02Icon class="h-5 w-5 text-on-sidebar" />
    </CPBadge>
  </CPButton>
</template>

<style scoped>
  .topbar-chat-badge :deep(.hr-badge-sup) {
    background-color: var(--cp-error-600);
  }

  .topbar-chat-badge :deep(.hr-badge-sup .hr-base-slot-machine) {
    color: var(--cp-text-on-error) !important;
  }
</style>
